import ExitPopupComponent from '../../../../components/exit-popup/exit-popup';
import index from './index';

const configuredExitPopupComponent = index(ExitPopupComponent);
export default configuredExitPopupComponent;
